export const isEditor3 = () => {
  // @ts-expect-error
  return self?.commonConfig?.host === 'EDITOR3';
};
